import * as React from 'react'

import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

interface Props {
  url: string
  name: string
}

const EmployeeCell = ({ url, name }: Props) => {
  return (
    <Box flexDirection="row" alignItems="center" gap="s16">
      <Avatar url={url} size="s24" label="" />
      <Text.Normal weight="medium">{name}</Text.Normal>
    </Box>
  )
}

export default observer(EmployeeCell)
